import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";
import urls from "../../../Utils/urls";

// export const fetchScheduledReport = createAsyncThunk(
//   "reportDocument/fetchScheduledReport",
//   async () => {
//     try {
//       const userId = localStorage.getItem("apex_userid");
//       const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
//         .value;
//       const res = await axios.get(
//         urls.reportsNDocuments.getScheduledReport(userId, userRole)
//       );
//       let data = res.data.schedule_reports?.map((data) => ({
//         ...data,
//         reportFormat: data.reportFormat.label,
//         repeat: `${data.repeat}`.toUpperCase(),
//         report_custom_name: data.parameters.report.label,
//       }));
//       return data;
//     } catch (error) {
//       console.error(error);
//       // toast.warning(`No Report Scheduled`, {
//       //   ...commonToast,
//       // });
//       return [];
//     }
//   }
// );
export const fetchScheduledReport = createAsyncThunk(
  "reportDocument/fetchScheduledReport",
  async ({ signal }) => {
    try {
      const userId = localStorage.getItem("apex_userid");
      const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
        .value;
      const res = await axios.get(
        urls.reportsNDocuments.getScheduledReport(
          userId,
          userRole,
          "SCHEDULED"
        ),
        {
          headers: {
            Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
          },
        },
        { signal }
      );
      let data = res.data.items;
      data = data.map((item) => {
        const jsonData = item.json_data;
        return {
          report_custom_name: jsonData?.report_details?.report_custom_name,
          date: jsonData?.report_details?.date,
          time: jsonData?.report_details?.time,
          repeat: `${jsonData?.report_details?.repeat}`,
          reportFormat: jsonData?.report_details?.reportFormat,
          deliveryMethord: jsonData?.report_details?.deliveryMethods,
          id: item?.id,
          reportData: jsonData,
          frequency: jsonData?.report_details?.Frequency,
          delete: jsonData,
          last_run_date: item?.last_run_date,
          next_run_date: item?.next_run_date,
          is_active_main: item?.is_active
        };
      });
      return data;
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);

export const fetchScheduledReportDetailByID = createAsyncThunk(
  "reportDocument/fetchScheduledReportDetailByID",
  async ({ signal, reportId }) => {
    try {
      const userId = localStorage.getItem("apex_userid");
      const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
        .value;
      const res = await axios.get(
        urls.reportsNDocuments.getScheduledReportDetailsByID(
          userId,
          userRole,
          "SCHEDULED",
          reportId
        ),
        {
          headers: {
            Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
          },
        },
        { signal }
      );
      let data = res.data.items;
      data = data.map((item) => {
        const jsonData = item.json_data;
        return {
          report_custom_name: jsonData?.report_details?.report_custom_name,
          date: jsonData?.report_details?.date,
          time: jsonData?.report_details?.time,
          repeat: `${jsonData?.report_details?.repeat}`,
          reportFormat: jsonData?.report_details?.reportFormat,
          deliveryMethord: jsonData?.report_details?.deliveryMethods,
          id: item?.id,
          reportData: {...jsonData, id: reportId,},
          frequency: jsonData?.report_details?.Frequency,
          delete: jsonData,
          last_run_date: item?.last_run_date,
          next_run_date: item?.next_run_date,
        };
      });
      return data;
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);

export const deleteScheduledReport = createAsyncThunk(
  "reportDocument/deleteScheduledReport",
  async ({ id, fetchSave, signal, payloadForDelete }) => {
    try {
      // const userId = localStorage.getItem("apex_userid");
      // const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
      //   .value;
      // const res = await axios.delete(
      //   // urls.reportsNDocuments.deleteScheduledReport(userId, userRole, id),
      //   urls.reportsNDocuments.deleteScheduledReport(id),
      //   {
      //     headers: {
      //       Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
      //     },
      //   },
      //   { signal }
      // );
      const res = await axios.post(
        // urls.reportsNDocuments.deleteScheduledReport(userId, userRole, id),
        urls.reportsWidget.deleteReport,
        payloadForDelete,
        {
          headers: {
            Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
          },
        },
      );

      if (res.status == "200") {
        await fetchSave();
      }
      // let data = res.data.schedule_reports?.map((data) => ({
      //   ...data,
      //   reportFormat: data.reportFormat.label,
      //   repeat: `${data.repeat}`.toUpperCase(),
      // }));
      // return data;
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  },
);
export const deleteSaveReport = createAsyncThunk(
  "reportDocument/deleteSaveReport",
  async ({ id, fetchSave, signal, payloadForDelete }) => {
    try {
      // const userId = localStorage.getItem("apex_userid");
      // const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
      //   .value;
      // const res = await axios.delete(
      //   // urls.reportsNDocuments.deleteSaveReport(userId, userRole, id),
      //   urls.reportsNDocuments.deleteSaveReport(id),
      //   {
      //     headers: {
      //       Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
      //     },
      //   },
      //   { signal }
      // );

       const res = await axios.post(
        urls.reportsWidget.deleteReport,
        payloadForDelete,
        {
          headers: {
            Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
          },
        },
      );

      if (res.status == "200") {
        await fetchSave();
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);
export const fetchSaveReport = createAsyncThunk(
  "reportDocument/fetchSaveReport",
  async ({ signal }) => {
    try {
      const userId = localStorage.getItem("apex_userid");
      const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
        .value;
      const res = await axios.get(
        urls.reportsNDocuments.getSavedReport(userId, userRole, "SAVED"),
        {
          headers: {
            Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
          },
        },
        { signal }
      );
      let data = res.data.items;
      data = data.map((item) => {
        const jsonData = item.json_data;
        return {
          ...jsonData,
          report_custom_name: jsonData?.report_details?.report_custom_name,
          is_favorite: jsonData?.report_details.favorite ? "True" : "False",
          reportName: jsonData?.report_details?.report?.label,
          loanId: jsonData?.report_details?.lenderID[0]?.value,
          id: item.id,
        };
      });
      return data;
      // return {
      //   // favouriteReport: finalResult?.filter((data) => data.favorite === true),
      //   saveReport: res.data.items,
      // };
      // return res.data.items;
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Save & Favourite Report`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);
// export const fetchSaveReport = createAsyncThunk(
//   "reportDocument/fetchSaveReport",
//   async () => {
//     try {
//       const userId = localStorage.getItem("apex_userid");
//       const userRole = JSON.parse(localStorage.getItem("account")).selectedRole
//         .value;
//       const res = await axios.get(
//         urls.reportsNDocuments.getSavedReport(userId, userRole)
//       );
//       let data = res.data.saved_reports;

//       const finalResult = data?.map((data) => ({
//         ...data,
//         reportName: data.report.label || data.report,
//         is_favorite: data.favorite && `${data.favorite}`.toUpperCase(),
//       }));

//       return {
//         favouriteReport: finalResult?.filter((data) => data.favorite === true),
//         saveReport: finalResult,
//       };
//     } catch (error) {
//       console.error(error);
//       // toast.warning(`No Save & Favourite Report`, {
//       //   ...commonToast,
//       // });
//       return {
//         favouriteReport: [],
//         saveReport: [],
//       };
//     }
//   }
// );

export const fetchReportList = createAsyncThunk(
  "reportDocument/fetchReportList",
  async ({ signal }) => {
    try {
      const userId = localStorage.getItem("apex_userid");
      const roleId = JSON.parse(localStorage.getItem("account")).selectedRole
        .id;
      const res = await axios.get(
        urls.reportsNDocuments.getReportList(roleId, userId),
        {
          headers: {
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        },
        { signal }
      );
      if (res) {
        const data = res?.data?.items;
        return data;
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);

export const fetchReportDetail = createAsyncThunk(
  "reportDocument/fetchReportDetail",
  async ({ reportId, signal }) => {
    try {
      const userId = localStorage.getItem("apex_userid");
      const roleId = JSON.parse(localStorage.getItem("account")).selectedRole
        .id;
      const res = await axios.get(
        urls.reportsNDocuments.getReportDetail(roleId, userId, reportId),
        {
          headers: {
            Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
          },
        },
        { signal }
      );
      if (res) {
        const data = res?.data;
        return data;
      }
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        console.error(error);
      }
      // console.error(error);
      // toast.warning(`No Report Scheduled`, {
      //   ...commonToast,
      // });
      return [];
    }
  }
);
